export default __webpack_public_path__ + "static/media/6-acts-of-testing.925e41e0.svg";